import React from "react";
import { motion } from "framer-motion";
import AnimatedCounter from "@/components/shared/AnimatedCounter";

const stats = [
  { prefix: "", to: 2021, suffix: "", label: "depuis", desc: "Fondé à Vichy, Auvergne" },
  { prefix: "+", to: 11000, suffix: "", label: "livraisons", desc: "Effectuées avec succès" },
  { prefix: "+", to: 120, suffix: "", label: "clients", desc: "Nous font confiance" },
  { prefix: "+", to: 50, suffix: "", label: "pays", desc: "Destinations à l'international" },
  { prefix: "+", to: 1300, suffix: "", label: "transporteurs partenaires", desc: "Réseau national & européen" },
];

const STAT_ANIMS_MOBILE = stats.map((_, i) => ({
  initial: { opacity: 0, x: -20 },
  whileInView: { opacity: 1, x: 0 },
  viewport: { once: true },
  transition: { duration: 0.4, delay: i * 0.08 },
}));

const STAT_ANIMS_DESKTOP = stats.map((_, i) => ({
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5, delay: i * 0.1 },
}));

export default function StatsSection() {
  return (
    <section className="py-12 md:py-20 bg-[#1e3a52] relative overflow-hidden" data-testid="stats-section">
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: "linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)",
          backgroundSize: "60px 60px"
        }}
      />
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#E8902A]/30 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#E8902A]/30 to-transparent" />

      <div className="relative max-w-7xl mx-auto px-4 md:px-12">
        {/* Mobile : liste verticale */}
        <div className="flex flex-col md:hidden divide-y divide-white/5">
          {stats.map((stat, i) => (
            <motion.div
              key={stat.label}
              {...STAT_ANIMS_MOBILE[i]}
              className="flex items-center gap-4 py-4 px-2"
              data-testid={`stat-${stat.label}`}
            >
              <div className="font-heading font-black text-4xl gradient-text leading-none w-28 flex-shrink-0 text-right">
                <AnimatedCounter prefix={stat.prefix} to={stat.to} suffix={stat.suffix} duration={1.8} />
              </div>
              <div>
                <div className="font-heading font-bold text-white text-sm uppercase tracking-wide">{stat.label}</div>
                <div className="text-slate-500 text-xs">{stat.desc}</div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Desktop : grille */}
        <div className="hidden md:grid md:grid-cols-5 gap-4">
          {stats.map((stat, i) => (
            <motion.div
              key={stat.label}
              {...STAT_ANIMS_DESKTOP[i]}
              className="text-center border-r last:border-r-0 border-white/5 px-4 py-0"
              data-testid={`stat-${stat.label}-desktop`}
            >
              <div className="font-heading font-black text-5xl gradient-text mb-2 leading-tight">
                <AnimatedCounter prefix={stat.prefix} to={stat.to} suffix={stat.suffix} duration={1.8} />
              </div>
              <div className="font-heading font-bold text-white text-sm tracking-wide uppercase mb-1">
                {stat.label}
              </div>
              <div className="text-slate-500 text-xs leading-relaxed">{stat.desc}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
